import * as React from 'react'
import classNames from 'classnames'
import './index.css'

export default function TextError ({ className, ...rest }) {
  className = classNames(className, {
    'text-error': true
  })

  return (
    <span className={className} {...rest} />
  )
}
